module.exports = __webpack_public_path__ + "img/chinchilla_contact.07fe6bb9.jpeg";